import React, {memo, useCallback, useEffect, useMemo} from "react";
import NewsTicker from "./NewsTicker";
import {directMessagesRef, firestore, tickersRef, tickerStateRef, usersRef} from "../../config/firebaseConfig"
import UsersListChat from "../dirrectMessages/UsersListChat";
import OtherUserChat from "../dirrectMessages/OtherUserChat";
import HelpdeskModal from "../common/HelpdeskModal";
import {makeStyles} from "@material-ui/core/styles";
import HelpFaqLinks from "./HelpFaqLinks";
import MessagesLink from "./MessagesLink";
import {useParams} from "react-router";
import firebase from "firebase";

const useStyles = makeStyles({})

function sortUsers(user) {
    return function sortComp(u1, u2) {
        if (u1.CustID === user.CustID)
            return -1
        else if (u2.CustID === user.CustID)
            return 1
        else if (u1.lastNewMsg > u2.lastNewMsg)
            return -1
        else if (u2.lastNewMsg > u1.lastNewMsg)
            return 1
        else if (u1.chatted > u2.chatted)
            return -1
        else if (u2.chatted > u1.chatted)
            return 1
        else if (u1.FirstName !== u2.FirstName)
            return u1.FirstName.localeCompare(u2.FirstName)
        else return u1.LastName.localeCompare(u2.LastName)
        // if (u1.CustID === user.CustID)
        //     return -1
        // else if (u2.CustID === user.CustID)
        //     return 1
        // else if (u1.viewed ^ u2.viewed)
        //     return u1.viewed - u2.viewed
        // else if (u1.chatted ^ u2.chatted)
        //     return u1.chatted - u2.chatted
        // else if (u1.chatted && u2.chatted && u1.chatted !== u2.chatted)
        //     return u1.chatted - u2.chatted
        // else if (u1.viewed && u2.viewed && u1.viewed !== u2.viewed)
        //     return u1.viewed - u2.viewed
        // else if (u1.FirstName !== u2.FirstName)
        //     return u1.FirstName.localeCompare(u2.FirstName)
        // else return u1.LastName.localeCompare(u2.LastName)
    }
}

const AppFooter = ({isSpecial, path, hideStatus, setHideStatus, users, onlineUsers, user}) => {
    const [width, setWidth] = React.useState(window.innerWidth > 900 ? window.innerWidth * 0.03 : window.innerWidth * 0.05);
    const [modal, toggleModal] = React.useState(false);
    const [chats, setChats] = React.useState([]);
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const [alreadyChatted, setAlreadyChatted] = React.useState({});
    const [lastNewMsg, setLastNewMsg] = React.useState({});


    const classes = useStyles();

    const getGroupChatId = (currentUserId, currentPeerUser) => {
        if (currentUserId <= currentPeerUser)
            return `${currentUserId}-${currentPeerUser}`;
        else return getGroupChatId(currentPeerUser, currentUserId)
    };

    React.useEffect(() => {
        function handleResize() {
            if (window.innerWidth > 900) {
                setWidth(window.innerWidth * 0.03)
            } else {
                setWidth(window.innerWidth * 0.05)
            }
        }

        window.addEventListener('resize', handleResize)
    }, []);

    // messages viewed
    useEffect(() => {
        let unsubscribes = []
        if (user && onlineUsers) {
            unsubscribes = onlineUsers.map(u => {
                const id = getGroupChatId(user.CustID, u.CustID);
                return firebase.database().ref(`directChatsStatus/${id}/lastNewMsg/${user.CustID}`)
                    .on('value', snapshot => {
                        if (snapshot) {
                            setLastNewMsg(s => ({...s, [u.CustID]: snapshot.val()}))
                        }
                    })
            });
        }
        return () => {
            unsubscribes.forEach(_ => _())
        }
    }, [onlineUsers, user])


    // chatted
    useEffect(() => {
        let unsubscribes = []
        if (user && onlineUsers) {
            unsubscribes = onlineUsers.map(u => {
                const id = getGroupChatId(user.CustID, u.CustID);
                return firebase.database().ref(`directChatsStatus/${id}/chatted`)
                    .on('value', snapshot => {
                        if (snapshot) {
                            setAlreadyChatted(s => ({...s, [u.CustID]: snapshot.val()}))
                        }
                    })
            });
        }
        return () => {
            unsubscribes.forEach(_ => _())
        }
    }, [onlineUsers, user])


    const openChat = userId => {
        if (!chats.includes(userId) && user.CustID !== userId) {
            if (chats.length < 3) {
                setChats([...chats, userId]);
            } else {
                chats.pop();
                setChats([...chats, userId]);
            }
        }
    };


    const deleteFromChatsPanel = otherUserId => {
        setChats(chats.filter(id => id !== otherUserId));
    };


    const usersWithChattedAndLastMsg = useMemo(
        () => {
            const arr = (user && alreadyChatted && onlineUsers) ? onlineUsers.map(u => ({
                ...u,
                chatted: alreadyChatted[u.CustID],
                lastNewMsg: lastNewMsg[u.CustID]
            })) : null
            if (arr)
                arr.sort(sortUsers(user))
            return arr
        },
        [user, users, onlineUsers]
    )


    if (isSpecial) {
        return null;
    }

    // console.log('unread', hasUnread)

    return (
        <div className={'footer-container'} style={{zIndex: 3}}>
            <HelpFaqLinks width={width} onHelpClick={() => setModalIsOpen(true)}/>
            {!path.includes('photobooth') && <NewsTicker/>}
            {/*<HelpdeskModal modalIsOpen={modalIsOpen} closeModal={() => setModalIsOpen(false)}/>*/}
            {/*{user && <UsersListChat users={usersWithChattedAndLastMsg}*/}
            {/*                        open={modal}*/}
            {/*                        hideStatus={hideStatus}*/}
            {/*                        setHideStatus={setHideStatus}*/}
            {/*                        closeModal={() => toggleModal(!modal)}*/}
            {/*                        user={user}*/}
            {/*                        openChat={openChat}*/}
            {/*/>}*/}
            {/*{*/}
            {/*    chats != null ? chats.map((otherUserId, index) => {*/}
            {/*            const groupChatId = getGroupChatId(user.CustID, otherUserId);*/}
            {/*            return (<OtherUserChat user={user}*/}
            {/*                                   key={groupChatId}*/}
            {/*                                   otherUser={users.find(u => u.CustID === otherUserId)}*/}
            {/*                                   index={index}*/}
            {/*                                   groupChatId={groupChatId}*/}
            {/*                                   deleteFromChatsPanel={deleteFromChatsPanel}*/}
            {/*            />)*/}
            {/*        })*/}
            {/*        :*/}
            {/*        null*/}
            {/*}*/}
            <MessagesLink width={width} onClick={() => toggleModal(true)}/>
        </div>
    )
};

export default memo(AppFooter);


